import React, { useCallback, useRef, useContext } from 'react'
import CruiseLinesSearchList from './CruiseLinesSearchList'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane/Pane'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import useToggle from 'hooks/useToggle'
import styled from 'styled-components'
import { rem } from 'polished'

const DropdownFooter = styled(Pane)`
  padding: ${rem(16)} 0;
`

interface Props {
  cruiseLineLabel: string
  onChange: (values: App.CruiseGlobalFilters) => void
  dropdownAnchorRef?: React.RefObject<HTMLElement>
}

function CruiseLineDesktopInput({ cruiseLineLabel, onChange, dropdownAnchorRef }: Props) {
  const inputTriggerRef = useRef<HTMLButtonElement>(null)
  const [isOpen, toggleModal] = useToggle(false)
  const { cruiseLines } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const onApply = useCallback(() => {
    onChange({ cruiseLines })
    toggleModal()
  }, [onChange, cruiseLines, toggleModal])

  const onClear = useCallback(() => {
    searchDispatch({ type: GlobalSearchStateActions.SET_CRUISE_LINES, cruiseLines: [] })
    onChange({ cruiseLines: [] })
    toggleModal()
  }, [onChange, searchDispatch, toggleModal])

  return <>
    <SearchFormField
      onClick={toggleModal}
      ref={inputTriggerRef}
      label="Cruise lines"
      placeholder="All cruise lines"
      value={cruiseLineLabel}
    />

    <Dropdown
      triggerRef={inputTriggerRef}
      anchorRef={dropdownAnchorRef}
      open={isOpen}
      onClose={toggleModal}
      floatingStrategy="absolute"
      width="100%"
      position="bottom"
      disableFlip
    >
      <DropdownContainer fit="container">
        <LayoutContainer>
          <CruiseLinesSearchList />
        </LayoutContainer>

        <DropdownFooter shadow>
          <LayoutContainer>
            <Group direction="horizontal" horizontalAlign="end" gap={16}>
              <TextButton
                kind="tertiary"
                onClick={onClear}
              >
                Clear
              </TextButton>
              <TextButton
                kind="primary"
                onClick={onApply}
              >
                Apply
              </TextButton>
            </Group>
          </LayoutContainer>
        </DropdownFooter>
      </DropdownContainer>
    </Dropdown>
  </>
}

export default CruiseLineDesktopInput
